"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDataLayerExperiments = exports.userIdentifier = exports.seperateEncodedFlags = exports.encodeLdCookieValue = exports.decodeVariant = exports.encodeVariant = exports.encodeLdFlags = exports.variantCheck = exports.stripExpPrefix = exports.parseLdFlagKey = exports.getExperiment = exports.getFeatureFlag = void 0;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const getFeatureFlag = (flags, flagKey, overrides) => {
    /*
      get override if present
      if flags don't exist, we want to default the experience to
      "off" as well as convey a null value for a secondary check if needed
  */
    const isOverridden = Boolean(overrides && (overrides[flagKey] !== undefined));
    const flagValue = isOverridden ? overrides[flagKey] : flags ? flags[flagKey] : null;
    return {
        isOn: Boolean(flagValue),
        isOff: !flagValue,
        value: flagValue,
        isOverridden
    };
};
exports.getFeatureFlag = getFeatureFlag;
const getExperiment = (flags, flagKey, overrides) => {
    const trimmedKey = stripExpPrefix(flagKey);
    /*
      get override if present
      if flags don't exist, we want to default the experience to
      "v0" as well as convey a null value for a secondary check if needed
  */
    const isOverridden = Boolean(overrides && (overrides[trimmedKey] !== undefined));
    const expValue = isOverridden ? overrides[trimmedKey] : flags ? flags[trimmedKey] : null;
    return {
        /* NOTE: if values are defined outside of v* convetion, `value` can still be leveraged */
        isV0: !expValue ? true : variantCheck(expValue, 'v0'),
        isV1: variantCheck(expValue, 'v1'),
        isV2: variantCheck(expValue, 'v2'),
        value: expValue,
        isOverridden
    };
};
exports.getExperiment = getExperiment;
const parseLdFlagKey = (flagKey) => {
    let prefix;
    let name;
    let ticket;
    if (/^[^.]+[.][^.]+[.][^.]+$/.test(flagKey)) {
        // parse experiment flag that follows expected naming convention
        [prefix, name, ticket] = flagKey.split('.');
    }
    else if (/^(?!EXP[.])[^.]+[.][^.]+$/.test(flagKey)) {
        // parse feature flag key that follows expected naming convention
        // omit any flag that starts with 'EXP.', since that's the prefix for an experiment flag
        [name, ticket] = flagKey.split('.');
    }
    else {
        // if the key is malformed, return the name containing the entire key
        name = flagKey;
    }
    // ensure strings are returned
    return {
        prefix: prefix || '',
        name: name || '',
        ticket: ticket || ''
    };
};
exports.parseLdFlagKey = parseLdFlagKey;
const stripExpPrefix = (key) => {
    const { name, ticket } = parseLdFlagKey(key);
    /* we can evaluate if truthy because if ticket doesn't exist, '' is returned */
    const ticketSuffix = ticket && `.${ticket}`;
    return `${name}${ticketSuffix}`;
};
exports.stripExpPrefix = stripExpPrefix;
const variantCheck = (expValue, valueToCheck) => {
    return expValue && expValue === valueToCheck;
};
exports.variantCheck = variantCheck;
const encodeLdFlags = (flags) => {
    const encodedFlags = {};
    const flagKeys = Object.keys(flags);
    /* for now we will persist the full flag key, including
  ticket, as we require it for local overrides as long as
  we persist tickets in the code-referenced key name) */
    flagKeys.forEach((key) => {
        const formattedVariant = encodeVariant(flags[key]);
        encodedFlags[key] = {
            encodedVariation: formattedVariant,
            decodedKey: key,
            decodedVariation: flags[key]
        };
    });
    return encodedFlags;
};
exports.encodeLdFlags = encodeLdFlags;
// Encode variant for cookie
// transforms override values from ldo cookie || widget selection
const encodeVariant = (variant) => {
    if (variant === true || variant === 'true') {
        return 't';
    }
    if (variant === false || variant === 'false') {
        return 'f';
    }
    return variant;
};
exports.encodeVariant = encodeVariant;
// decode variant from cookie
// transforms query string true/false to boolean
const decodeVariant = (variant) => {
    if (variant === 't' || variant === 'true') {
        return true;
    }
    if (variant === 'f' || variant === 'false') {
        return false;
    }
    return variant;
};
exports.decodeVariant = decodeVariant;
// combine encoded keys and variants into a single string
const encodeLdCookieValue = (flags) => {
    const encodedFlags = encodeLdFlags(flags);
    const encodedFlagList = [];
    Object.keys(encodedFlags).forEach((key) => {
        encodedFlagList.push(`${key}=${encodedFlags[key].encodedVariation}`);
    });
    return encodedFlagList.join('!');
};
exports.encodeLdCookieValue = encodeLdCookieValue;
// seperate cookie string into encoded key/variant pairs e.g.
const seperateEncodedFlags = (encodedOverrideCookie) => {
    const encodedOverrideList = encodedOverrideCookie.split('!');
    const overrides = {};
    encodedOverrideList.forEach((encodedOverride) => {
        const [key, value] = encodedOverride.split('=');
        overrides[key] = value;
    });
    return overrides;
};
exports.seperateEncodedFlags = seperateEncodedFlags;
const userIdentifier = (customer = null) => {
    let key = 'saatva-anonymous';
    let name = 'Saatva User';
    let email = 'dev-user@saatvamattress.com';
    if (customer && customer.email) {
        key = customer.email;
        name = customer.firstName;
        email = customer.email;
    }
    return {
        key,
        name,
        email
    };
};
exports.userIdentifier = userIdentifier;
const buildDataLayerExperiments = (experiments, flagOverrides) => {
    return Object.entries(experiments).reduce((expData, [key, value]) => {
        // if experiment variant is overridden, do not add exeriment data to dataLayer
        if (flagOverrides.hasOwnProperty(key)) {
            return { ...expData };
        }
        const { name, ticket } = parseLdFlagKey(key);
        const formattedName = name.toLowerCase().replace(/_/g, '-');
        const formattedTicket = ticket ? `-${ticket.toLowerCase()}` : '';
        return {
            ...expData,
            [name]: `${formattedName}${formattedTicket}-${value}`
        };
    }, {});
};
exports.buildDataLayerExperiments = buildDataLayerExperiments;
//# sourceMappingURL=utils.js.map